"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropListItemRadioGroup = void 0;
var React = require("react");
var DropList_styles_1 = require("./DropList.styles");
var DropListItemRadioGroup = function (_a) {
    var Items = _a.Items, Name = _a.Name, Value = _a.Value, OnClick = _a.OnClick;
    var _b = React.useState(Value), value = _b[0], setValue = _b[1];
    var handleRowClick = function (e, item) {
        // stopping propagation so we can see the checkbox change.
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
        if (!item.Disabled) {
            setValue(item.Value);
            OnClick(item);
        }
    };
    return (React.createElement(React.Fragment, null, Items.map(function (item) {
        return React.createElement(DropList_styles_1.MenuRow, { key: item.Value, role: "none" },
            React.createElement(DropList_styles_1.ClickRow, { "aria-disabled": item.Disabled, role: "menuitem", tabIndex: -1, onClick: function (e) { return handleRowClick(e, item); } },
                React.createElement(DropList_styles_1.IconBlock, null,
                    React.createElement("input", { "aria-label": item.Caption, checked: item.Value === value, name: Name, value: item.Value, type: "radio", tabIndex: -1 })),
                React.createElement(DropList_styles_1.Caption, null, item.Caption)));
    })));
};
exports.DropListItemRadioGroup = DropListItemRadioGroup;
